import type { MusicOnHoldLocale } from './en'

export const musicOnHoldTeIn = {
  list: {
    title: `హోల్డ్‌లో సంగీతం`,
    loading: `ప్లేలిస్ట్‌లు లోడ్ అవుతున్నాయి...`,
    error: `లోపం`,
    empty: `ప్లేలిస్ట్‌లు కనుగొనబడలేదు`,
    emptyDescription: `ఈ PBX కోసం ప్రస్తుతం ఏ ప్లేలిస్ట్‌లు కాన్ఫిగర్ చేయబడలేదు.`,
    noResults: `ఫలితాలు లేవు`,
    noResultsDescription: `మీ శోధనకు సరిపోలే ప్లేలిస్ట్‌లు లేవు.`,
    columnName: `పేరు`,
    columnType: `రకం`,
    columnTracks: `ట్రాక్‌లు`,
    columnUpdated: `నవీకరించబడింది`,
    columnDefault: `డిఫాల్ట్`,
    columnPlayer: `ప్రివ్యూ`,
    noPreview: `ఆడియో లేదు`,
    previewInDetail: `ట్రాక్‌లను ప్రివ్యూ చేయడానికి తెరవండి`,
    defaultDisabledTooltip: `డిఫాల్ట్‌గా సెట్ చేయడానికి ప్లేలిస్ట్‌కు కనీసం ఒక ఆడియో ట్రాక్ లేదా స్ట్రీమ్ URL ఉండాలి.`,
    defaultCurrentTooltip: `ఇది ప్రస్తుత డిఫాల్ట్ ప్లేలిస్ట్.`,
    defaultSetTooltip: `డిఫాల్ట్ ప్లేలిస్ట్‌గా సెట్ చేయండి`,
    defaultBadge: `డిఫాల్ట్`,
    systemBadge: `సిస్టమ్`,
    notPlayableBadge: `ప్లే చేయలేము`,
    typeList: `జాబితా`,
    tracksLabel: `ట్రాక్‌లు`,
    streaming: `స్ట్రీమింగ్`,
    myPlaylists: `నా ప్లేలిస్ట్‌లు`,
    systemPlaylists: `సిస్టమ్ ప్లేలిస్ట్‌లు`,
    searchPlaceholder: `ప్లేలిస్ట్‌లు శోధించండి...`,
    manageTracksButton: `ఆడియో ట్రాక్‌లు`,
    createButton: `+ ప్లేలిస్ట్ సృష్టించండి`,
    createDisabledTooltip: `ప్లేలిస్ట్ సృష్టించడం ఇంకా అందుబాటులో లేదు.`,
    columnActions: `చర్యలు`,
    deleteAriaLabelNamed: `"{{name}}" ప్లేలిస్ట్‌ను తొలగించండి`,
    deleteConfirmTitle: `ప్లేలిస్ట్‌ను తొలగించాలా?`,
    deleteConfirmBody: `"{{name}}"ను తొలగించాలా? ఈ చర్యను రద్దు చేయలేము.`,
    deleteConfirm: `తొలగించండి`,
    deleteCancel: `రద్దు చేయండి`,
    deleteDefaultWarning: `ఇది డిఫాల్ట్ హోల్డ్-మ్యూజిక్ ప్లేలిస్ట్. దీన్ని తొలగిస్తే సిస్టమ్ డిఫాల్ట్‌కు మారుతుంది.`,
  },
  detail: {
    loading: `ప్లేలిస్ట్ లోడ్ అవుతోంది...`,
    error: `లోపం`,
    notFound: `ప్లేలిస్ట్ కనుగొనబడలేదు.`,
    backToList: `← జాబితాకు తిరిగి వెళ్ళండి`,
    editButton: `ప్లేలిస్ట్ సవరించండి`,
    editDisabledTooltip: `సవరణ ఇంకా అందుబాటులో లేదు`,
    defaultBadge: `డిఫాల్ట్`,
    systemBadge: `సిస్టమ్`,
    generalTitle: `సాధారణ సమాచారం`,
    nameLabel: `పేరు`,
    typeLabel: `రకం`,
    typeList: `జాబితా`,
    defaultLabel: `డిఫాల్ట్`,
    defaultYes: `అవును`,
    defaultNo: `కాదు`,
    activeLabel: `యాక్టివ్`,
    activeYes: `అవును`,
    activeNo: `కాదు`,
    idLabel: `ID`,
    uuidLabel: `UUID`,
    createdLabel: `సృష్టించబడింది`,
    updatedLabel: `నవీకరించబడింది`,
    audioTracksTitle: `ఆడియో ట్రాక్‌లు`,
    noAudioTracks: `ఈ ప్లేలిస్ట్‌కు అనుబంధించబడిన ఆడియో ట్రాక్‌లు లేవు.`,
    manageTracksButton: `ట్రాక్‌లను నిర్వహించండి`,
  },
  audioTracks: {
    title: `ఆడియో ట్రాక్‌లు`,
    loading: `ఆడియో ట్రాక్‌లు లోడ్ అవుతున్నాయి...`,
    empty: `ఈ PBX కోసం ఏ ఆడియో ట్రాక్‌లు అప్‌లోడ్ చేయబడలేదు.`,
    columnName: `పేరు`,
    columnFile: `ఫైల్`,
    uploadButton: `సంగీతం అప్‌లోడ్ చేయండి`,
    close: `మూసివేయండి`,
    nameLabel: `ట్రాక్ పేరు`,
    namePlaceholder: `ట్రాక్ పేరును నమోదు చేయండి`,
    nameRequired: `దయచేసి ట్రాక్ కోసం పేరును నమోదు చేయండి.`,
    audioFileRequired: `దయచేసి ఒక ఆడియో ఫైల్‌ను ఎంచుకోండి.`,
    fileTypeInvalid: `WAV లేదా MP3 ఫైల్‌లు మాత్రమే మద్దతు ఇస్తాయి.`,
    fileSizeExceeded: `ఫైల్ 25 MB పరిమితిని మించిపోయింది ({{size}} MB).`,
    dropzonePlaceholder: `WAV లేదా MP3 ఫైల్‌ను ఇక్కడ లాగి వదలండి లేదా బ్రౌజ్ చేయడానికి క్లిక్ చేయండి`,
    dropzoneAccepted: `WAV, MP3 (గరిష్టం 25 MB)`,
    removeFile: `తొలగించండి`,
    cancel: `రద్దు చేయండి`,
    uploadSubmit: `అప్‌లోడ్ చేయండి`,
    uploading: `అప్‌లోడ్ అవుతోంది...`,
    uploadFailed: `అప్‌లోడ్ విఫలమైంది`,
    deleteConfirmTitle: `ఆడియో ట్రాక్‌ను తొలగించాలా?`,
    deleteConfirmBody: `"{{name}}"ను తొలగించాలా? ఈ చర్యను రద్దు చేయలేము.`,
    deleteConfirm: `తొలగించండి`,
    deleteFailed: `తొలగించడం విఫలమైంది`,
    deleteAriaLabel: `ఆడియో ట్రాక్‌ను తొలగించండి`,
  },
  createModal: {
    title: `కొత్త ప్లేలిస్ట్`,
    nameLabel: `పేరు`,
    namePlaceholder: `ప్లేలిస్ట్ పేరు నమోదు చేయండి`,
    cancel: `మూసివేయండి`,
    submit: `ప్లేలిస్ట్ సృష్టించండి`,
  },
  editModal: {
    title: `ప్లేలిస్ట్ సవరించండి`,
    nameLabel: `పేరు`,
    namePlaceholder: `ప్లేలిస్ట్ పేరు నమోదు చేయండి`,
    cancel: `రద్దు చేయండి`,
    submit: `మార్పులను సేవ్ చేయండి`,
    error: `ప్లేలిస్ట్ సేవ్ చేయడం విఫలమైంది`,
  },
  manageTracks: {
    title: `ట్రాక్‌లను నిర్వహించండి`,
    inPlaylistTitle: `ఈ ప్లేలిస్ట్‌లో`,
    availableTitle: `అందుబాటులో ఉన్న ట్రాక్‌లు`,
    noneAssigned: `ఈ ప్లేలిస్ట్‌కు ఇంకా ట్రాక్‌లు జోడించబడలేదు.`,
    noTracksUploaded: `ఈ PBX కోసం ఏ ఆడియో ట్రాక్‌లు అప్‌లోడ్ చేయబడలేదు.`,
    allAdded: `అందుబాటులో ఉన్న అన్ని ట్రాక్‌లు ఇప్పటికే ఈ ప్లేలిస్ట్‌లో ఉన్నాయి.`,
    add: `జోడించండి`,
    remove: `తొలగించండి`,
    done: `పూర్తయింది`,
    addFailed: `ట్రాక్ జోడించడం విఫలమైంది`,
    removeFailed: `ట్రాక్ తొలగించడం విఫలమైంది`,
  },
  trackPlay: {
    play: `ప్లే చేయండి`,
    loading: `లోడ్ అవుతోంది…`,
    error: `ప్రివ్యూ అందుబాటులో లేదు`,
    close: `ప్రివ్యూ మూసివేయండి`,
  },
  pagination: {
    resultsPerPage: `పేజీకి ఫలితాలు:`,
    previousPage: `మునుపటి పేజీ`,
    nextPage: `తరువాతి పేజీ`,
    jumpToPage: `{{page}} పేజీకి వెళ్ళండి`,
    all: `అన్నీ`,
  },
} satisfies MusicOnHoldLocale
